$(function () {
    
    let dayCount = 1;

    // show・hide equipments according to selected room
    $(document).on('change', '.estimate-room', function () {
        var selected = $(this).val();
        var parent = $(this).closest('.room-group');

        if (selected.indexOf('京都府茶業会館') !== -1) {
            parent.find('.chagyoEquip').show();
            parent.find('.ujichaEquip').hide();
        } else if (selected.indexOf('宇治茶会館') !== -1) {
            parent.find('.ujichaEquip').show();
            parent.find('.chagyoEquip').hide();
        } else {
            parent.find('.chagyoEquip').hide();
            parent.find('.ujichaEquip').hide();
        }
    });

    $('#estimate-form').on('submit', function (e) {
        e.preventDefault();
        let validRequire = true;
        let validRoom = true;

        // validate select
        $(this).find('.required').each(function () {
            if ($(this).find('select').val() === '') {
                $(this).next('.error-message').show();
                validRequire = false;
            } else {
                $(this).next('.error-message').hide();
            }
        });


        // validate room
        $('.day-group').each(function () {
            const combinations = [];

            $(this).find('.room-group').each(function () {
                const room = $(this).find('.estimate-room').val();
                const time = $(this).find('.estimate-time').val();
                const key = room + '-' + time;

                if (room && time) {
                    if (combinations.includes(key)) {
                        validRoom = false;
                        return false;
                    }
                    combinations.push(key);
                }
            });

            if (!validRoom) return false;
        });

        if (!validRoom && validRequire) {
            $('.error-room').show();
        } else {
            $('.error-room').hide();
        }

        if (validRoom && validRequire) {
            $('#estimate-form').hide();
            $('#estimate-results').show();
            const total = getTotal();
            const data = getSelectedData();
            window.scrollTo(0, 0);

        }
    });

    const $first = $(`.day-group[data-day="1"]`);
    $first.find('.add-room').on('click', function () {
        addRoom($first.find('.rooms'), false);
    });

    $('.add-day').on('click', function () {
        addDay();
    });

    function addDay() {
        dayCount++;
        const dayHtml = `
          <tr class="day-group" data-day="${dayCount}">
            <th>${dayCount}日目</th>
            <td>
            <a class="remove-day"></a>
            <p class="error-room">会議室と時間帯の選択が重複しています</p>
            <div class="rooms"></div>
            <a class="add-room"><span></span>施設欄を追加する</a>
            </td>
            <hr>
          </tr>
        `;
        $('#daysContainer').append(dayHtml);

        const $day = $(`.day-group[data-day="${dayCount}"]`);
        addRoom($day.find('.rooms'), true);

        $day.find('.add-room').on('click', function () {
            addRoom($day.find('.rooms'), false);
        });

        $day.find('.remove-day').on('click', function () {
            $day.remove();
        });

    }

    function addRoom($container, first) {
        const roomHtml = `
            <div class="estimate__item room-group">
                ${!first ? '<a class="remove-room"></a>' : ''}
                <div class="estimate__select">
                    <div class="estimate__select-item">
                        <label for="estimate-room">使用会場</label>
                        <div class="select required">
                            <select name="estimate-room" class="estimate-room">
                                <option value="" disable>会議室を選択してください</option>
                                <option value="京都府茶業会館　第1研修室（1階）">京都府茶業会館　第1研修室（1階）</option>
                                <option value="京都府茶業会館　第2研修室（1階）">京都府茶業会館　第2研修室（1階）</option>
                                <option value="京都府茶業会館　第3研修室＆和室（2階）">京都府茶業会館　第3研修室＆和室（2階）</option>
                                <option value="宇治茶会館　大ホール（3階）">宇治茶会館　大ホール（3階）</option>
                                <option value="宇治茶会館　第1会議室（2階）">宇治茶会館　第1会議室（2階）</option>
                                <option value="宇治茶会館　第2会議室（2階）">宇治茶会館　第2会議室（2階）</option>
                                <option value="宇治茶会館　ピロティ（1階）">宇治茶会館　ピロティ（1階）</option>
                            </select>
                        </div>
                        <p class="error-message">使用会場を選択してください</p>
                    </div>

                    <div class="estimate__select-item">
                        <label for="estimate-time">時間帯</label>
                        <div class="select required">
                            <select name="estimate-time" class="estimate-time">
                                <option value="" disable>時間帯を選択してください</option>
                                <option value="午前 9:00～12:00">9:00-12:00</option>
                                <option value="午後 13:00-17:00">13:00-17:00</option>
                                <option value="9:00-17:00">9:00-17:00</option>
                            </select>
                        </div>
                        <p class="error-message">時間帯を選択してください</p>
                    </div>
                </div>

                <div class="estimate__equipments chagyoEquip">
                    <p>備品</p>
                    <div class="estimate__equipments-options">
                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="1大型モニター">
                            <span class="checkmark"></span>
                            大型モニター
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="1プロジェクター">
                            <span class="checkmark"></span>
                            プロジェクター
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="1モバイルスクリーン">
                            <span class="checkmark"></span>
                            モバイルスクリーン
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="1レーザーポインター">
                            <span class="checkmark"></span>
                            レーザーポインター
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="1ポータブルマイク">
                            <span class="checkmark"></span>
                            ポータブルマイク
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="1Web会議用システム（8-30名用）">
                            <span class="checkmark"></span>
                            Web会議用システム（8-30名用）
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="1Web会議用システム（4-10名用）">
                            <span class="checkmark"></span>
                            Web会議用システム（4-10名用）
                        </label>

                    </div>
                </div>

                <div class="estimate__equipments ujichaEquip">
                    <p>備品</p>
                    <div class="estimate__equipments-options">
                        <div class="estimate__equipments-select">
                            <div class="select --sm">
                                <select name="estimate-wirelessmic" class="estimate-wirelessmic">
                                    <option value="" disable>個数</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                </select>
                            </div>
                            <label for="estimate-wirelessmic">ワイアレスマイク</label>
                        </div>

                        <div class="estimate__equipments-select">
                            <div class="select --sm">
                                <select name="estimate-pinmic" class="estimate-pinmic">
                                    <option value="" disable>個数</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                </select>
                            </div>
                            <label for="estimate-wirelessmic">ピンマイク</label>
                        </div>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="2有線マイク">
                            <span class="checkmark"></span>
                            有線マイク
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="2ハイブリッド会議システム">
                            <span class="checkmark"></span>
                            ハイブリッド会議システム
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="2Web会議用システム（8-30名用）">
                            <span class="checkmark"></span>
                            Web会議用システム（8-30名用）
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="2Web会議用システム（4-10名用）">
                            <span class="checkmark"></span>
                            Web会議用システム（4-10名用）
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="2ポータブルマイク">
                            <span class="checkmark"></span>
                            ポータブルマイク
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="2ホワイトボード">
                            <span class="checkmark"></span>
                            ホワイトボード
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="2プロジェクター">
                            <span class="checkmark"></span>
                            プロジェクター
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="2レーザーポインター">
                            <span class="checkmark"></span>
                            レーザーポインター
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="2大型モニター">
                            <span class="checkmark"></span>
                            大型モニター
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="2モバイルスクリーン">
                            <span class="checkmark"></span>
                            モバイルスクリーン
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="2電動スクリーン">
                            <span class="checkmark"></span>
                            電動スクリーン
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="2演台(90cm)">
                            <span class="checkmark"></span>
                            演台(90cm)
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="2演台(60cm)">
                            <span class="checkmark"></span>
                            演台(60cm)
                        </label>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="2花台">
                            <span class="checkmark"></span>
                            花台
                        </label>

                        <div class="estimate__equipments-select">
                            <div class="select --sm">
                                <select name="estimate-hoiro" class="estimate-hoiro">
                                    <option value="" disable>個数</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                    <option value="16">16</option>
                                    <option value="17">17</option>
                                    <option value="18">18</option>
                                    <option value="19">19</option>
                                    <option value="20">20</option>
                                </select>
                            </div>
                            <label for="estimate-wirelessmic">焙炉</label>
                        </div>

                        <label class="checkbox">
                            <input type="checkbox" name="options[]" value="2給茶セット">
                            <span class="checkmark"></span>
                            給茶セット
                        </label>
                    </div>
                </div>
            </div>
        `;
        $container.append(roomHtml);
    }

    function getSelectedData() {
        const data = [];

        $('.day-group').each(function () {
            const day = $(this).data('day');
            const rooms = [];

            // get selected items
            $(this).find('.room-group').each(function () {
                const room = $(this).find('.estimate-room').val();
                const time = $(this).find('.estimate-time').val();
                const equipments = $(this).find('input[name="options[]"]:checked')
                    .map(function () {
                        return $(this).val();
                    }).get();
                const wirelessMic = $(this).find('.estimate-wirelessmic').val();
                const pinmic = $(this).find('.estimate-pinmic').val();
                const hoiro = $(this).find('.estimate-hoiro').val();

                rooms.push({ room, time, equipments, wirelessMic, pinmic, hoiro });
            });

            data.push({ day, rooms });
        });

        return data;
    }

    function getTotal() {
        let total = 0;
        const prices = {
            '京都府茶業会館　第1研修室（1階）': {
                '午前 9:00～12:00': 3700,
                '午後 13:00-17:00': 5000,
                '9:00-17:00': 7300
            },
            '京都府茶業会館　第2研修室（1階）': {
                '午前 9:00～12:00': 3700,
                '午後 13:00-17:00': 5000,
                '9:00-17:00': 7300
            },
            '京都府茶業会館　第3研修室＆和室（2階）': {
                '午前 9:00～12:00': 5700,
                '午後 13:00-17:00': 8000,
                '9:00-17:00': 11400
            },
            '宇治茶会館　大ホール（3階）': {
                '午前 9:00～12:00': 16800,
                '午後 13:00-17:00': 23800,
                '9:00-17:00': 33000
            },
            '宇治茶会館　第1会議室（2階）': {
                '午前 9:00～12:00': 2200,
                '午後 13:00-17:00': 2800,
                '9:00-17:00': 4600
            },
            '宇治茶会館　第2会議室（2階）': {
                '午前 9:00～12:00': 4500,
                '午後 13:00-17:00': 5600,
                '9:00-17:00': 9300
            },
            '宇治茶会館　ピロティ（1階）': {
                '午前 9:00～12:00': 2000,
                '午後 13:00-17:00': 3000,
                '9:00-17:00': 4500
            }
        };

        const equipPrices = {
            '1大型モニター': 3000,
            '1プロジェクター': 3000,
            '1モバイルスクリーン': 500,
            '1レーザーポインター': 200,
            '1ポータブルマイク': 1000,
            '1Web会議用システム（8-30名用）': 3000,
            '1Web会議用システム（4-10名用）': 1000,

            '2有線マイク': 300,
            '2ハイブリッド会議システム': 5000,
            '2Web会議用システム（8-30名用）': 3000,
            '2Web会議用システム（4-10名用）': 1000,
            '2ポータブルマイク': 1000,
            '2ホワイトボード': 1000,
            '2プロジェクター': 500,
            '2レーザーポインター': 200,
            '2大型モニター': 3000,
            '2モバイルスクリーン': 500,
            '2電動スクリーン': 1000,
            '2演台(90cm)': 500,
            '2演台(60cm)': 500,
            '2花台': 300,
            '2給茶セット': 300,
        }

        const wirelessmicPrice = 300;
        const pinmicPrice = 300;
        const hoiroPrice = 3500;

        const data = getSelectedData();
        data.forEach(day => {
            day.rooms.forEach(room => {
                // get room prices
                let rPrice = prices[room.room][room.time];
                let ePrice = 0;
                let wmPrice = room.wirelessMic * wirelessmicPrice;
                let pmPrice = room.pinmic * pinmicPrice;
                let hPrice = room.hoiro * hoiroPrice;
                
                // set data in results table
                let selectedEquip = "";
                if (room.wirelessMic > 0) {
                    selectedEquip += "ワイアレスマイク x " + room.wirelessMic + "<br>";
                }
                if (room.pinmic > 0) {
                    selectedEquip += "ピンマイク x " + room.pinmic + "<br>";
                }
                room.equipments.forEach(equip => {
                    ePrice += equipPrices[equip];
                    selectedEquip += equip.substring(1) + "<br>";
                });

                if (room.hoiro > 0) {
                    selectedEquip += "焙炉 x " + room.hoiro;
                }

                const roomResult = `
                <tr>
                    <td>${room.room}</td>
                    <td>${room.time}</td>
                    <td>${selectedEquip}</td>
                </tr>
                `;
                $('.table-results').append(roomResult);

                // calc total
                total += rPrice + ePrice + wmPrice + pmPrice + hPrice;
            });
        });

        const currencyFormat = total.toLocaleString('ja-JP');
        $('.total-budget').text(currencyFormat+'円（税込み）');
    }

    $(document).on('click', '.remove-room', function () {
        $(this).closest('.room-group').remove();
    });
});